// V97 — Per-landing-page phone number routing.
//
// Rules (user-set, February 2026):
//   /home-tuition-jabalpur, /online-tuition-jabalpur, any /*jabalpur*    → 9993305574
//   /home-tuition-bhopal,   /online-tuition-bhopal,   any /*bhopal*      → 7974221232
//   /home-tuition-nagpur,   /online-tuition-nagpur,   any /*nagpur*      → 8087198495
//   /online-makeover-classes*, /makeover-classes-* (any Makeover page)   → 8085796268
//   Everything else (Pan India + Worldwide default)                      → 7000530316
//
// Same rule is applied to the WhatsApp click-through, so every button in
// the header / footer / hero / CTA of a given landing page opens the
// matching WhatsApp number.

import { useLocation } from "react-router-dom";

const PHONES = {
    jabalpur:  { display: "+91 99933 05574", raw: "919993305574", tel: "+919993305574" },
    bhopal:    { display: "+91 79742 21232", raw: "917974221232", tel: "+917974221232" },
    nagpur:    { display: "+91 80871 98495", raw: "918087198495", tel: "+918087198495" },
    makeover:  { display: "+91 80857 96268", raw: "918085796268", tel: "+918085796268" },
    default:   { display: "+91 70005 30316", raw: "917000530316", tel: "+917000530316" },
};

function resolveKey(pathname = "/") {
    const p = pathname.toLowerCase();
    // Makeover has highest precedence (a Jabalpur-specific Makeover page is
    // still a Makeover landing — must show the Makeover number).
    if (p.includes("makeover-classes") || p.includes("/makeover")) return "makeover";
    if (p.includes("jabalpur")) return "jabalpur";
    if (p.includes("bhopal")) return "bhopal";
    if (p.includes("nagpur")) return "nagpur";
    return "default";
}

export function usePagePhone() {
    const { pathname } = useLocation();
    const key = resolveKey(pathname);
    const phone = PHONES[key];
    const waMsg = encodeURIComponent(
        "Hi, I'm interested in Anand Tutorials. Please share details."
    );
    return {
        key,
        display: phone.display,               // "+91 99933 05574"
        raw: phone.raw,                       // "919993305574"       (E.164 no plus)
        tel: phone.tel,                       // "+919993305574"      (for href="tel:")
        whatsapp: `https://wa.me/${phone.raw}?text=${waMsg}`,
        whatsappBare: `https://wa.me/${phone.raw}`,
    };
}

// Non-hook resolver — for places that don't have hooks (e.g. inside Helmet).
// Callers pass the current `pathname` explicitly.
export function resolvePagePhone(pathname) {
    return PHONES[resolveKey(pathname)];
}

export const PAGE_PHONES = PHONES;
